(function () {
  'use strict';

  // Registry: sectionId -> { product, currentVariant, subscribers: [] }
  var registry = {};

  function getProductJSON(sectionRoot) {
    var script = sectionRoot.querySelector('script[type="application/json"][data-product-json]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function getInitialVariantId(form) {
    var url = new URL(window.location.href);
    var qv  = url.searchParams.get('variant');
    if (qv) return parseInt(qv, 10);
    var hidden = form.querySelector('input[name="id"]');
    return hidden ? parseInt(hidden.value, 10) : null;
  }

  function readFormOptions(form) {
    var selects = form.querySelectorAll('select[data-variant-option]');
    var values = [];
    selects.forEach(function (s) { values.push(s.value); });
    return values;
  }

  function findVariantByOptions(product, optionValues) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var j = 0; j < optionValues.length; j++) {
        if (v.options[j] !== optionValues[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function findVariantById(product, id) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === id) return product.variants[i];
    }
    return null;
  }

  // Fallback für nicht existente Options-Kombinationen (sparse Varianten-Matrix):
  // bevorzugt eine VERFÜGBARE Variante mit dem gerade geklickten Wert, sonst die
  // erste mit dem Wert. Die aufrufende Stelle synchronisiert danach alle <select>s
  // auf die Fallback-Variante — UI und versteckte id bleiben so immer konsistent.
  function resolveFallbackVariant(product, changedIndex, changedValue) {
    var fallback = null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.options[changedIndex] !== changedValue) continue;
      if (v.available) return v;
      if (!fallback) fallback = v;
    }
    return fallback;
  }

  function dispatchChange(sectionRoot, sectionId, variant) {
    registry[sectionId].currentVariant = variant;
    var ev = new CustomEvent('trautis:variant-change', {
      bubbles: true,
      detail: { sectionId: sectionId, variant: variant }
    });
    sectionRoot.dispatchEvent(ev);
    // JEDES versteckte id-Feld der Section nachziehen: das Haupt-ATC-Form UND
    // das separate Express-Checkout-Form (#product-form-express) tragen je ein
    // input[name="id"] — nur das erste zu setzen ließe Shop Pay & Co. die
    // initial gerenderte Variante kaufen statt der gewählten.
    if (variant) {
      var ids = sectionRoot.querySelectorAll('input[name="id"]');
      for (var i = 0; i < ids.length; i++) ids[i].value = variant.id;
    }
  }

  function initSection(sectionRoot) {
    var sectionId = sectionRoot.getAttribute('data-section-id');
    if (!sectionId || registry[sectionId]) return;
    var product = getProductJSON(sectionRoot);
    if (!product) return;
    var form = sectionRoot.querySelector('[data-product-form]');
    if (!form) return;

    registry[sectionId] = { product: product, currentVariant: null, subscribers: [] };

    // Initial variant resolution
    var initialId = getInitialVariantId(form);
    var initialVariant = initialId ? findVariantById(product, initialId) : null;
    if (!initialVariant) {
      // Fall back to first available
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) { initialVariant = product.variants[i]; break; }
      }
      if (!initialVariant) initialVariant = product.variants[0];
    }

    // Set <select>s to match the initial variant
    var selects = form.querySelectorAll('select[data-variant-option]');
    selects.forEach(function (s, idx) {
      if (initialVariant && initialVariant.options[idx] != null) {
        s.value = initialVariant.options[idx];
      }
    });

    // Listen to changes
    selects.forEach(function (s, selIdx) {
      s.addEventListener('change', function () {
        var vals = readFormOptions(form);
        var v = findVariantByOptions(product, vals);
        if (!v) {
          // Kombination existiert nicht (sparse Matrix): auf eine echte Variante
          // mit dem gerade gewählten Wert ausweichen und die übrigen <select>s
          // mitziehen. Ohne das bliebe die versteckte id auf der ALTEN Variante,
          // während die Buttons die neue (ungültige) Auswahl zeigen — ATC würde
          // eine andere SKU einwerfen als angezeigt.
          var changedIndex = parseInt(s.getAttribute('data-option-index'), 10);
          if (isNaN(changedIndex)) changedIndex = selIdx;
          v = resolveFallbackVariant(product, changedIndex, s.value);
          if (v) {
            selects.forEach(function (sel, idx) {
              if (v.options[idx] != null) sel.value = v.options[idx];
            });
          }
        }
        if (v) dispatchChange(sectionRoot, sectionId, v);
      });
    });

    // Initial dispatch
    dispatchChange(sectionRoot, sectionId, initialVariant);
  }

  // Public API (initSection nur für den Test-Harness exponiert)
  window.TrautisVariantReactivity = {
    findVariantByOptions: findVariantByOptions,
    resolveFallbackVariant: resolveFallbackVariant,
    initSection: initSection,
    getCurrentVariant: function (sectionId) {
      return registry[sectionId] ? registry[sectionId].currentVariant : null;
    },
    subscribe: function (sectionId, handler) {
      var root = document.querySelector('[data-section-id="' + sectionId + '"][data-product-section]');
      if (!root) return function () {};
      var wrapped = function (e) { handler(e.detail); };
      root.addEventListener('trautis:variant-change', wrapped);
      return function () { root.removeEventListener('trautis:variant-change', wrapped); };
    }
  };

  // Pill row toggling (in-module so we don't need a separate file)
  function bindPillRow(sectionRoot) {
    var pillRow = sectionRoot.querySelector('[data-pill-row]');
    if (!pillRow) return;
    var sectionId = sectionRoot.getAttribute('data-section-id');
    var product = registry[sectionId] && registry[sectionId].product;
    if (!product) return;

    function resolvePill(key, variant) {
      // Variant metafield > product metafield > tag > false.
      // Liquid initial render handled SSR; JS resolves post-change.
      var vMf = variant.metafields && variant.metafields.legal;
      if (vMf && vMf[key] != null) return !!vMf[key];
      var pMf = product.metafields && product.metafields.legal;
      if (pMf && pMf[key] != null) return !!pMf[key];
      var tagKey = key === 'motorsport_only' ? 'legal:motorsport-only' : 'legal:' + key.replace('has_', '');
      return product.tags && product.tags.indexOf(tagKey) >= 0;
    }

    sectionRoot.addEventListener('trautis:variant-change', function (e) {
      var v = e.detail.variant;
      pillRow.querySelectorAll('[data-pill-key]').forEach(function (pill) {
        var key = pill.getAttribute('data-pill-key');
        if (resolvePill(key, v)) pill.removeAttribute('hidden');
        else pill.setAttribute('hidden', '');
      });
    });
  }

  // Init
  function init() {
    document.querySelectorAll('[data-product-section]').forEach(function (root) {
      initSection(root);
      bindPillRow(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Node.js / test harness export
if (typeof module !== 'undefined' && module.exports) {
  module.exports = (typeof window !== 'undefined' && window.TrautisVariantReactivity) || {
    getCurrentVariant: function () { return null; },
    subscribe: function () { return function () {}; }
  };
}
